import { Component, OnInit, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ErrorStateMatcher } from '@angular/material/core';
import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ConfirmDialogComponent } from './../../../../common/components/confirm-dialog/confirm-dialog.component';
import { SliderModelService } from './../../../../services/infrastructure/sliderModel.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { LolLoggerService } from './../../../../common/shared/lol-logger.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { CommonService } from './../../../../services/common/common.service';
import * as $ from 'jquery';
import { SeedReservationService } from '../../../../../../src/app/services/seed/seed-reservation.service';
import { SeedReplantService } from '../../../../services/seed/seed-replant/seed-replant.service';
import { DashboardFilter } from './../../../../models/DashboardFilter';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-seed-reservation-confirmation',
  templateUrl: './seed-reservation-confirmation.component.html',
  styleUrl: './seed-reservation-confirmation.component.scss'
})
export class SeedReservationConfirmationComponent implements OnInit, AfterViewInit, OnDestroy {
  // ===============================
  // ✅ Primitive Type Variables
  // ===============================
  showTabs = false;
  shipToDataLoading: boolean = true;
  hasChangeAdded = false;
  isPlaceOrderDisable = true;
  isNotValid = false;
  isAddingNewItem = false;
  readOnlyAccess = false;
  selectedCount = 0;
  searchCount = 0;
  dataCount = 0;
  isUpdateRequest: boolean = false;
  tabNode: '';
  newItemName = '';
  emailAddress: string;
  duplicateCombinationError: string;
  selectedItemId: number | null = null;

  // ===============================
  // ✅ Array Type Variables
  // ===============================
  subscription = new Array<Subscription>();
  productList: any[] = [];
  marketingBrandList: any[] = [];
  updatedProductList: any[] = [];
  updatedMarketingBrandList: any[] = [];
  ddldeliveryList = [
    { id: 'Y', value: 'Yes' },
    { id: 'N', value: 'No' }
  ];
  selectedItems: any[] = [];
  newItemList: any[] = [];
  dataSource: any[] = [];
  displayedColumns: string[] = ['select', 'productLine', 'marketingBrand', 'labelQty'];

  // ===============================
  // ✅ Object / Any Type Variables
  // ===============================
  shipToData: any;
  userMenuAccessList: any;
  formdata: any;
  growerLoading: any;
  growerList: any;
  headerYear: any;
  shipToAccount: any;
  selectedProductLineId: any;
  selectedMarketingBrandId: any;
  reservationData: any;
  headerId: any;
  isInMobileApp = false;

  // ===============================
  // ✅ Constant / Class Instances
  // ===============================
  dashboardFilter: DashboardFilter;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  matcher = new InputErrorStateMatcher(this.isNotValid);


  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,
    private matDialog: MatDialog,
    private commonService: CommonService,
    private datePipe: DatePipe,
    public broadcastService: BroadcastService,
    private configService: ConfigService,
    public sliderModelService: SliderModelService,
    public seedReservationService: SeedReservationService,
    public seedReplantService: SeedReplantService) {
    this.dashboardFilter = new DashboardFilter();
    //this.addReservationRow();
  }

  ngOnInit(): void {
    this.isInMobileApp = this.isInWebView();
    this.setDefaultformData()
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).userMenuAccessList;
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.SEED_RESERVATION)) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SEED_RESERVATION, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.subscription.push(this.seedReservationService.seedReservationId.subscribe(x => {
            if (x[0] && x[0] != 0) {
              this.isUpdateRequest = x[1];
              this.getOrderDetails(x[0]);
            } else {
              this.readOnlyAccess = !x[1];
            }
          }));
        }
        else {
          this.router.navigate(['/cc/landing-data']);
        }
      }
    }

  }

  ngAfterViewInit() {
    this.setTableHeight();
    this.setHeight();
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setTableHeight();
    this.setHeight();
  }

  isInWebView(): boolean {
    const ua = navigator.userAgent || '';

    // React Native WebView
    if ((window as any).ReactNativeWebView) return true;

    // iOS WebView: AppleWebKit but NOT Safari
    const isIOS = /iPhone|iPod|iPad/i.test(ua);
    const isIOSWebView = isIOS && /AppleWebKit/.test(ua) && !/Safari/.test(ua);

    // Android WebView: look for 'wv' or no 'Chrome' version string
    const isAndroidWebView = /; wv/.test(ua) || (/Android/.test(ua) && !/Chrome\/\d/.test(ua));

    return isIOSWebView || isAndroidWebView;
  }

  setHeight() {
    if (window.innerWidth < 767) {
      const templateHeight = window.innerHeight - 200;
      $('.productLabelFormPage').css('max-height', templateHeight + 'px');
    }
  }

  setTableHeight() {
    setTimeout(function () {
      const templateMinHeight = window.innerHeight - $('h3').outerHeight() - $('.OrderReleaseTop').outerHeight() - $('.productsection').outerHeight() - 190;
      const templateMaxHeight = window.innerHeight - $('h3').outerHeight() - $('.OrderReleaseTop').outerHeight() - $('.productsection').outerHeight() - 189;

      $('.tableOuterContainer').css('min-height', templateMinHeight + 'px');
      $('.tableOuterContainer').css('max-height', templateMaxHeight + 'px');
    }, 100);
  }

  ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  setDefaultformData() {
    this.formdata = {
      accountNumber: null,
      accountName: null,
      address: null,
      city: null,
      state: null,
      zipCode: null,
      overNightDelivery: "N",
      orderedBy: null,
      accountManager: null,
      attn: null,
      email: null,
      customerPO: null,
      orderedDate: this.datePipe.transform(new Date(), 'MM/dd/yyyy'),
      cppproductLabelItems: []
    };
  }

  getOrderDetails(seedReservationId: number) {
    this.loaderService.setLoaderStatus(true);

    const confirmation$ = this.seedReservationService.getConfirmationData(seedReservationId);
    const masterData$ = this.seedReservationService.getSeedReservationMasterData(true);

    this.subscription.push(
      forkJoin([confirmation$, masterData$]).subscribe(
        ([confirmationResult, masterDataResult]: any[]) => {
          this.productList = masterDataResult.productLines;
          this.marketingBrandList = masterDataResult.marketingBrands;
          this.updatedProductList = masterDataResult.forUpdateProductLines;
          this.updatedMarketingBrandList = masterDataResult.forUpdateMarketingBrand;
          this.reservationData = confirmationResult;
          this.headerId = confirmationResult.seedReservationHeaderID;
          this.selectedItems = [];

          confirmationResult.productDetails.forEach(x => {
            const productLine = this.updatedProductList.find(item => item.id === x.productLineId);
            const marketingBrand = this.updatedMarketingBrandList.find(item => item.id === x.marketingBrandId);
            this.selectedItems.push({
              productLineId: x.productLineId,
              productLineName: productLine ? productLine.value : '',
              marketingBrandId: x.marketingBrandId,
              marketingBrandName: marketingBrand ? marketingBrand.value : '',
              quantity: x.units,
              selected: false,
              isEditable: x.isEditable || false,
            });
          });

          this.dataSource = [...this.selectedItems];
          this.selectedProductLineId = this.selectedItems.length > 0
            ? this.selectedItems[this.selectedItems.length - 1].productLineId
            : null;
          this.loaderService.setLoaderStatus(false);
        },
        (error) => {
          this.loaderService.setLoaderStatus(false);
          LolLoggerService.error(error);
        }
      )
    );
  }

  enableAllCheckBoxes(isChecked) {
    if (isChecked) {
      this.showTabs = true;
      this.selectedItems.forEach(x => {
        if (x.isEditable) {
          x.selected = true;
        }
      });
      this.selectedCount = this.selectedItems.length;
    }
    else {
      this.showTabs = false;
      this.selectedItems.forEach(x => {
        x.selected = false;
      });
      this.selectedCount = 0;
    }
  }

  enableCheckBoxSingle(isChecked) {
    this.isUpdateRequest = true;
    if (isChecked) {
      this.showTabs = true;
      this.selectedCount = this.selectedItems.filter(x => x.selected == true).length;
    }
    else {
      this.selectedCount = this.selectedItems.filter(x => x.selected == true).length;
      const checked = this.selectedItems.filter(x => x.selected == true);
      if (checked && checked.length == 0) {
        this.showTabs = false;
      }
    }
  }

  addReservationRow() {
    this.selectedItems.push({
      productLineId: this.selectedProductLineId ? this.selectedProductLineId : null,
      productLineName: '',
      marketingBrandId: null,
      marketingBrandName: '',
      quantity: 0,
      selected: false,
      newLine: true,
      isEditable: true,
      marketingBrandFilteredList: this.selectedProductLineId ? this.marketingBrandList.filter(x => x.productLineId == this.selectedProductLineId) : this.marketingBrandList
    });
    this.dataSource = [...this.selectedItems];
  }

  downloadPDF() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(
      this.seedReservationService.downloadPdfForMobile(this.headerId).subscribe(result => {
        if (this.isInMobileApp) {
          var fileData = {
            MobilePDFBase64: result.mobilePDFBase64,
            FileName: result.fileName
          };

          this.subscription.push(this.seedReservationService.sendBaseDate(fileData).subscribe((result) => {
            this.loaderService.setLoaderStatus(false);
          }, error => this.loaderService.setLoaderStatus(false)));
        }
        else {
          this.downloadFile(result.mobilePDFBase64, result.fileName);
        }     
        this.loaderService.setLoaderStatus(false);
      },
        () => {
          this.loaderService.setLoaderStatus(false);
        }
      )
    );
  }

  downloadFile(base64String, fileName) {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  onProductOrBrandChange(element, type) {
    if (type === "productLine") {
      element.marketingBrandId = ""
    }
    element.marketingBrandFilteredList = this.marketingBrandList.filter(x => x.productLineId == element.productLineId);
    const productLine = this.productList.find(item => item.id === element.productLineId);
    const marketingBrand = this.marketingBrandList.find(item => item.id === element.marketingBrandId);
    const isDuplicate = element.productLineId && element.marketingBrandId && this.selectedItems.some(
      x => x !== element &&
        x.productLineId === element.productLineId &&
        x.marketingBrandId === element.marketingBrandId
    );

    if (isDuplicate) {
      element.hasError = true;
      element.errorMessage = `The combination of ${productLine.value} and ${marketingBrand.value} already exists.`;
      this.isPlaceOrderDisable = true;
      return;
    }

    if (element.productLineId && element.marketingBrandId) {
      element.productLineName = productLine ? productLine.value : '';
      element.marketingBrandName = marketingBrand ? marketingBrand.value : '';
      element.hasError = false;
      element.errorMessage = '';
    } else {
      element.hasError = false;
      element.errorMessage = '';
    }

    this.dataSource = [...this.selectedItems]; // trigger table update
    this.validateRow(element);
    this.selectedProductLineId = this.selectedItems.length > 0
      ? this.selectedItems[this.selectedItems.length - 1].productLineId
      : null;
  }

  validateRow(element: any) {
    element.hasProductLineError = false;
    element.hasMarketingBrandError = false;

    if (element.quantity > 0) {
      if (!element.productLineId) {
        element.hasProductLineError = true;
      }

      if (!element.marketingBrandId) {
        element.hasMarketingBrandError = true;
      }
    }
  }

  setcount() {
    this.dataCount = this.selectedItems.filter(x => x.quantity > 0).length;
    this.isPlaceOrderDisable = this.dataCount > 0 ? false : true;
    this.hasChangeAdded = true;
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { plDataChange: true, labelNo: 'No,go Back to Reservation' });
  }

  navigateTolandingPage() {
    if (this.hasChangeAdded && this.isUpdateRequest) {
      const title = 'Leave without saving?';
      const message = '';
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No,go Back to Reservation ', dialogType: 'confirm' }
      });
      dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
          const closebutton = document.getElementsByClassName('close-btn')[0] as HTMLElement;
          closebutton.style.display = '';
          this.sliderModelService.close();
          this.router.navigate(['/seed-reservation-landing']);
        }
      });
    }
    else {
      const closebutton = document.getElementsByClassName('close-btn')[0] as HTMLElement;
      closebutton.style.display = '';
      this.sliderModelService.close();
      this.router.navigate(['/seed-reservation-landing']);
    }
  }

  deleteSelectedItems(value) {
    if (value) {
      const itemsToDelete = this.selectedItems.filter(item => item.selected);
      this.selectedItems = this.selectedItems.filter(item => !item.selected);
      this.dataSource = [...this.selectedItems];
      itemsToDelete.forEach(item => {
        if (item.itemId > 0) {
          const deletedItem = { itemId: item.id, productName: item.value };
          this.productList = [...this.productList, deletedItem];
        }
      });
      this.selectedProductLineId = this.selectedItems.length > 0
        ? this.selectedItems[this.selectedItems.length - 1].productLineId
        : null;
      this.selectedCount = 0;
      this.showTabs = false;
      this.productList.sort((a, b) => a.itemId - b.itemId);
      this.setcount();
    }
    this.tabNode = '';
  }

  showAddNewItemInput() {
    this.isAddingNewItem = true;
    this.setTableHeight();
  }

  quantityTextChange(productItem) {
    if (this.isUpdateRequest) {
      if (/^0/.test(productItem.quantity) && productItem.quantity != '0') {
        productItem.quantity = productItem.quantity.replace(/^0/, '');
      }
      this.validateRow(productItem);
      this.setcount();
    }

  }

  geuValueChange(value: string, element: any) {
    if (value == 'decrease') {
      const decValue = +element.quantity - 1;
      if (decValue > 0) {
        element.quantity = decValue;
      }
      else {
        element.quantity = 0;
      }
    }
    else {
      if (element.quantity <= 999998) {
        element.quantity = +element.quantity + 1;
      }
    }
    this.validateRow(element);
    this.setcount();
  }

  hasAnyError(): boolean {
    return this.dataSource?.some(item => item.hasError);
  }

  saveNewItem() {
    if (this.newItemName.trim()) {
      this.selectedItems.push({ itemId: 0, productName: this.newItemName, quantity: 0, selected: false });
      this.dataSource = [...this.selectedItems];
      // Clear the input and hide the new item input
      this.newItemName = '';
      this.isAddingNewItem = false;
    }
  }

  validateEmail(isave = false) {
    this.isNotValid = this.commonService.validateEmail(this.formdata.email, true);
    if (this.isNotValid && isave) {
      this.toastrService.warning('Enter a valid email.');
    }
    this.matcher = new InputErrorStateMatcher(this.isNotValid);
    return this.isNotValid;
  }

  isFormValid(): boolean {
    return this.selectedItems.every(item => {
      if (item.quantity === 0) {
        return true;
      }
      return !!item.productLineId && !!item.marketingBrandId;
    });
  }

  navigateToCreate() {
    this.router.navigate(['/seed-reservation/seed-reservation-create']);
  }

  saveOrder() {
    this.loaderService.setLoaderStatus(true);
    const selectedItems = this.selectedItems.filter(item => item.quantity > 0);
    const hasErrors = selectedItems.some(item =>
      item.hasError === true ||
      (item.errorMessage && item.errorMessage.length > 0)
    );
    if (hasErrors) {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Please resolve errors in selected items before proceeding.');
      return;
    }
    if (selectedItems.length > 0) {
      const saveObj: any = {};
      saveObj.shipToAccount = this.shipToAccount;
      saveObj.gmk = this.formdata.gmk;
      saveObj.seedHeaderId = this.headerId;
      saveObj.productDetails = [];
      selectedItems.forEach(x => {
        saveObj.productDetails.push({ productLineId: x.productLineId, marketingBrandId: x.marketingBrandId, units: x.quantity });
      });

      this.isPlaceOrderDisable = true;
      this.subscription.push(this.seedReservationService.SaveSeedReservation(saveObj).subscribe((result: any) => {
        if (result) {
          this.isUpdateRequest = false;
          this.selectedItems.forEach(x => {
            x.selected = false;
            x.newLine = false
          });

          this.selectedCount = 0;
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
          this.loaderService.setLoaderStatus(false);
          this.toastrService.success('The Reservation is Successfully updated.');
          //this.router.navigate(['/cpp/product-label-landing']);
        } else {
          this.isPlaceOrderDisable = false;
          this.loaderService.setLoaderStatus(false);
          this.toastrService.error('The Reservation not saved in the system.');
        }
      }))
        , (error) => {
          this.isPlaceOrderDisable = false;
          this.loaderService.setLoaderStatus(false);
          this.toastrService.error('The Reservation not saved in the system.');
          LolLoggerService.error(error);
        };
    }
    else {
      this.loaderService.setLoaderStatus(false);
      //  this.toastrService.warning('Enter a valid email.');
    }
  }
}

class InputErrorStateMatcher implements ErrorStateMatcher {
  constructor(private errorstate: boolean) { }
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return this.errorstate;
  }
}
